import { render, staticRenderFns } from "./InsightListPage.vue?vue&type=template&id=42858fde&scoped=true&"
import script from "./InsightListPage.vue?vue&type=script&lang=js&"
export * from "./InsightListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42858fde",
  null
  
)

export default component.exports